import { render, staticRenderFns } from "./blogsEditDetails.vue?vue&type=template&id=100402c5&"
import script from "./blogsEditDetails.vue?vue&type=script&lang=js&"
export * from "./blogsEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports